/* ============================================================
   Aurha Cart — motor de confete (canvas, sem lib externa)
   Cores oficiais da marca. Expõe window.aurhaConfetti().
   ============================================================ */
(function () {
  var COLORS = ['#8874D7', '#473582', '#D7CEFA', '#B8283A', '#EBEBEA'];
  var canvas, ctx, parts = [], running = false, hideTimer = null;

  function ensureCanvas() {
    if (canvas) return;
    canvas = document.createElement('canvas');
    canvas.className = 'aurha-confetti-canvas';
    // Estilos inline críticos — não depende do CSS carregar/aplicar
    canvas.style.cssText =
      'position:fixed;top:0;left:0;width:100vw;height:100vh;' +
      'pointer-events:none;z-index:2147483647;display:block;';
    document.body.appendChild(canvas);
    ctx = canvas.getContext('2d');
    window.addEventListener('resize', resize);
  }

  function resize() {
    if (!canvas) return;
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }

  function spawn(n) {
    var w = canvas.width;
    for (var i = 0; i < n; i++) {
      parts.push({
        x: Math.random() * w,
        y: -20 - Math.random() * (canvas.height * 0.3),
        w: 6 + Math.random() * 7,
        h: 9 + Math.random() * 8,
        color: COLORS[i % COLORS.length],
        vx: (Math.random() - 0.5) * 2.6,
        vy: 2.4 + Math.random() * 3.2,
        rot: Math.random() * 6.28,
        vr: (Math.random() - 0.5) * 0.32,
        life: 1
      });
    }
  }

  function loop() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      p.x += p.vx; p.y += p.vy; p.vy += 0.045; p.rot += p.vr;
      if (p.y > canvas.height * 0.66) p.life -= 0.018;
      ctx.save();
      ctx.globalAlpha = Math.max(0, p.life);
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.fillStyle = p.color;
      ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      ctx.restore();
    }
    parts = parts.filter(function (p) { return p.life > 0 && p.y < canvas.height + 40; });
    if (parts.length) {
      requestAnimationFrame(loop);
    } else {
      running = false;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      canvas.classList.remove('is-active');
      canvas.style.display = 'none';
    }
  }

  window.aurhaConfetti = function () {
    ensureCanvas();
    resize();
    canvas.classList.add('is-active');
    canvas.style.display = 'block';
    spawn(120);
    if (!running) { running = true; requestAnimationFrame(loop); }
    // segunda onda para um efeito mais cheio e notável
    setTimeout(function () {
      if (!canvas) return;
      canvas.classList.add('is-active');
      canvas.style.display = 'block';
      spawn(80);
      if (!running) { running = true; requestAnimationFrame(loop); }
    }, 450);
  };

  /* ---- Gatilho universal: confete sempre que a quantidade total do
     carrinho AUMENTA (adicionar produto OU clicar no + dentro do carrinho).
     Nunca dispara no - (menos) nem ao remover item.
     Cobre tema, PageFly, upsell, etc. */
  function confettiEnabled() {
    var cd = document.querySelector('cart-drawer');
    return cd && cd.getAttribute('data-aurha-confetti') === 'true';
  }
  function isCartAdd(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }
  function isCartChange(url) {
    return typeof url === 'string' && (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1);
  }

  var aurhaLastCount = null;
  function aurhaReadCount(cb) {
    fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cb(c.item_count); })
      .catch(function () {});
  }
  // baseline ao carregar a página
  aurhaReadCount(function (n) { aurhaLastCount = n; });

  function aurhaOnMutation(isAdd) {
    aurhaReadCount(function (n) {
      var increased = aurhaLastCount != null ? n > aurhaLastCount : isAdd;
      if (increased && confettiEnabled()) setTimeout(window.aurhaConfetti, 100);
      aurhaLastCount = n;
    });
  }

  // fetch()
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var promise = _fetch.apply(this, arguments);
      if (isCartAdd(url) || isCartChange(url)) {
        promise.then(function (res) {
          if (res && res.ok) aurhaOnMutation(isCartAdd(url));
          return res;
        }).catch(function () {});
      }
      return promise;
    };
  }

  // XMLHttpRequest (jQuery/PageFly/legado)
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._aurhaAdd = isCartAdd(url);
    this._aurhaChange = isCartChange(url);
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    if (self._aurhaAdd || self._aurhaChange) {
      this.addEventListener('load', function () {
        if (self.status >= 200 && self.status < 300) aurhaOnMutation(self._aurhaAdd);
      });
    }
    return _send.apply(this, arguments);
  };
})();
